import { saveAs } from "file-saver";
import { download as call } from "./";

export function download(attachment) {
  call("Attachments/Download/" + attachment.id).then((blob) => {
    saveAs(blob, attachment.filename);
  });
}
